module.exports = __webpack_public_path__ + "img/pin-requests.0ff1a5c3.svg";